import { useNavigate } from "react-router-dom";

function Topbar({ onMenuClick }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.clear();
        navigate("/admin/login");
    };

    const handleMenuClick = () => {
        console.log("Menu button clicked");
        if (onMenuClick) onMenuClick();
    };

    return (
        <div className="topbar">
            <div className="topbar-left">
                <button className="mobile-menu-toggle" onClick={handleMenuClick}>
                    <i className="fa fa-bars"></i>
                </button>
                <h4>Admin Dashboard</h4>
            </div>
            <div className="topbar-right">
                <button onClick={handleLogout} className="logout-btn">
                    <i className="fa fa-sign-out-alt me-2"></i>
                    <span>Logout</span>
                </button>
            </div>
        </div>
    );
}

export default Topbar;